import React, { useEffect } from 'react';
import { validate } from '../../../../helpers/validate';
import { useLang } from '../../../../hooks/use-lang';
import { useToggle } from '../../../../hooks/use-toggle';
import { useAuthStore } from '../../../../store/use-auth-store';

export const useRestore = () => {
  const { t, handleChangeLang } = useLang();
  const {
    restore,
    handleUpdateRestoreData,
    isLoading,
    restoreData,
    error,
    changePassword,
    changePasswordData,
    handleUpdateChangePasswordData,
    resetError,
  } = useAuthStore();
  const [isOk, , setIsOk] = useToggle();

  useEffect(() => {
    return () => resetError();
  }, [resetError]);

  const handleRestore = async () => {
    const isValid = validate({ email: { rule: () => !!restoreData?.email } });
    if (!isValid) return;
    setIsOk(await restore());
  };

  const handleUpdateNewPass = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleUpdateChangePasswordData({ password: e.currentTarget.value });
  };

  const handleUpdateRepeatPass = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleUpdateChangePasswordData({ repeatPassword: e.currentTarget.value });
  };

  const handleUpdateKey = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleUpdateChangePasswordData({ key: e.currentTarget.value });
  };

  const handleChangePassword = async () => {
    const isValid = validate({
      newPassword: { rule: () => !!changePasswordData?.password },
      repeatPassword: {
        rule: () =>
          !!changePasswordData?.repeatPassword &&
          changePasswordData?.password === changePasswordData?.repeatPassword,
      },
      key: { rule: () => !!changePasswordData?.key },
    });
    if (!isValid) return;
    await changePassword();
  };

  return {
    t,
    restore,
    handleUpdateRestoreData,
    isLoading,
    restoreData,
    error,
    isOk,
    handleRestore,
    changePasswordData,
    handleUpdateNewPass,
    handleUpdateRepeatPass,
    handleUpdateKey,
    handleChangePassword,
    handleChangeLang,
  };
};
